
<cvt-collapse
  :accordion="true"
  :theme="mode === 'LIGHT' ? 'light' : 'dark'"
  :prepend-chevron="prependChevron"
>
  <cvt-collapse-item
    v-if="containerItemSettings.isWrappedByCContainerItem"
    title="Container Item Options"
    :special-style="isSpecialStyle"
  >
    <c-container-item-options :mode="mode"/>
  </cvt-collapse-item>
  <cvt-collapse-item
    title="URL"
    name="url"
    :initial-active="true"
    :special-style="isSpecialStyle"
  >
    <cvt-alert color="primary" icon="info-circle">
      {{ $t('element.property.video.message') }}
    </cvt-alert>

    <cvt-input
      v-model="src"
      class="mt-2"
      :placeholder="$t('element.property.video.input.placeholder')"
      :label="
        !VideoMenuInputFloatingLabel
          ? $t('element.property.video.input.placeholder')
          : ''
      "
      :floating-label="VideoMenuInputFloatingLabel"
      autofocus
    >
    </cvt-input>

    <template v-if="sideBarVideoListOptions">
      <div class="divider mt-2" />

      <div class="col-md-12 mb-3 d-flex align-items-center text-capitalize">
        {{ $t('element.property.video.crm.video_list') }}
      </div>

      <video-list
        :value="crmRemoteVideoUrl"
        :mode="mode"
        endpoint="/v1/crm/media/lists"
        placeholder="Select Video"
        @videoSelectionUpdated="onVideoSelectionUpdated"
      />
    </template>
  </cvt-collapse-item>

  <cvt-collapse-item
    :title="$t('elements.properties.spacing.label')"
    name="spacing"
    :special-style="isSpecialStyle"
  >
    <spacing-ctrl></spacing-ctrl>
  </cvt-collapse-item>
  <cvt-collapse-item
    v-if="isGridBuilder"
    title="Style"
    name="style"
    :special-style="isSpecialStyle"
  >

    <!-- <div class="row">
      <div class="col-md-12 mb-3 d-flex align-items-center text-capitalize">
        {{ $t('elements.properties.background.color') }}
      </div>
      <div class="col-12">
        <colors alpha :mode="mode" />
      </div>
    </div>

    <div class="divider mt-2" /> -->

    <border-style-options
      :mode="mode"
      :border-style="selected.parent().borderStyle || 'none'"
      :border-color="selected.parent().borderColor || null"
      :border-width="selected.parent().borderWidth || 0"
      :border-radius="selected.parent().borderRadius || 0"
      :update-prop-function="selected.parent().updateProp"
    />
  </cvt-collapse-item>
</cvt-collapse>
